module.exports = __webpack_public_path__ + "static/img/listimg.071ad94d.jpg";